import { Component } from '@angular/core';
import { KeycloakAuthService } from 'src/app/auth/keycloak.service';

@Component({
  standalone: false,
  selector: 'app-account-complete',
  templateUrl: './account-complete.component.html',
  styleUrls: ['./account-complete.component.css']
})
export class AccountCompleteComponent {
  constructor(private keycloakAuthService: KeycloakAuthService) {}
  isPasswordUpdate: boolean = false
  heading = "Account Creation Complete"

  ngOnInit() {
    this.isPasswordUpdate = history.state.passwordUpdate
    this.heading = this.isPasswordUpdate ? "Password Update Complete" : this.heading
  }

  async login() {
    await this.keycloakAuthService.login()
  }
}
